// extracted by mini-css-extract-plugin
export default {"color":"AsEDGJurmWDWJo27WEX0","placeHolderShimmer":"RYGNWcbjb8PnQZtJc_93"};